import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import BaseInnerWrapper from '../../../global/InnerWrapper';
import Youtube from '../../../global/Youtube';
import Heading from './Heading';
import P from '../../../global/typography/P';
import Button from '../../../global/Button';
import NavLink from '../../../global/NavLink';

import { color, swatches } from '../../../../styles/theme';

const ParagraphColumn = styled.div`
  counter-reset: noble-list;
`;

const ButtonWrapper = styled.div`
  margin-top: 16px;

  @media (max-width: ${p => p.theme.deviceWidth.tablet}) {
    margin-bottom: 32px;
  }
`;

const VideoHeading = styled(Heading)`
  color: ${swatches.black};
`;

const OuterWrapper = styled(BaseInnerWrapper)`
  display: flex;
  justify-content: space-between;
  margin: 0 auto;

  @media ${p => p.theme.media.desktop} {
    align-items: center;
  }

  @media (max-width: ${p => p.theme.deviceWidth.tablet}) {
    align-items: flex-start;
    flex-direction: column;
  }
`;

const Paragraph = styled(P)`
  color: ${color.textPrimary};
  margin-bottom: 24px;
`;

const RedHighlight = styled.span`
  color: ${swatches.primary};
`;

const Wrapper = styled.section`
  color: ${swatches.white};
  padding: 60px 0;

  @media ${p => p.theme.media.tablet} {
    margin: 0;
  }
`;

const Content = styled.div`
  max-width: 500px;
  margin-right: 5%;

  @media ${p => p.theme.media.desktop} {
    margin-right: 3%;
  }
`;

const YoutubeWrapper = styled.div`
  max-width: 550px;
  width: 100%;
  flex-shrink: 0;

  @media ${p => p.theme.media.desktop} {
    flex-shrink: 1;
  }
`;

const VideoCard = ({ cta, heading, highlight, videoUrl, list, paragraphs }) => (
  <Wrapper>
    <OuterWrapper>
      <Content>
        <VideoHeading>
          {heading} <RedHighlight>{highlight}</RedHighlight>
        </VideoHeading>
        <ParagraphColumn>
          {paragraphs &&
            paragraphs.map((paragraph, i) => (
              <Paragraph key={i}>{paragraph}</Paragraph>
            ))}
        </ParagraphColumn>
        {cta && (
          <ButtonWrapper>
            <NavLink to={cta.url}>
              <Button>{cta.label}</Button>
            </NavLink>
          </ButtonWrapper>
        )}
      </Content>
      <YoutubeWrapper>
        <Youtube autoplay={false} url={videoUrl} />
      </YoutubeWrapper>
    </OuterWrapper>
  </Wrapper>
);

VideoCard.propTypes = {
  cta: PropTypes.shape({
    label: PropTypes.string,
    url: PropTypes.string
  }),
  heading: PropTypes.string.isRequired,
  highlight: PropTypes.string.isRequired,
  videoUrl: PropTypes.string.isRequired,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      body: PropTypes.string.isRequired,
      heading: PropTypes.string.isRequired
    })
  ),
  paragraphs: PropTypes.array.isRequired
};

export default VideoCard;
